<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>坏账商品列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <div style="display: flex; flex-direction: row">
                  <div
                    style="
                      width: 180px;
                      line-height: 40px;
                      font-size: 14px;
                      color: #606266;
                    "
                  >
                    搜索条件:
                  </div>
                  <div>
                    <el-form-item label="">
                      <el-input
                        v-model="form.goods_no"
                        placeholder="商品货号"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.goods_name"
                        placeholder="商品名称"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.market_name"
                        placeholder="市场"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.supply_name"
                        placeholder="商家"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.city"
                        placeholder="商家城市"
                        multiple
                        @keyup.native.enter="search"
                      >
                        <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.woid"
                        placeholder="代采单"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select v-model="form.pgid" placeholder="代采组">
                        <el-option :key="0" value="0" label="全部"></el-option>
                        <el-option
                          v-for="item in resData.pgOption"
                          :key="item.value"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select
                        v-model="form.order_owner"
                        filterable
                        placeholder="订单负责人"
                      >
                        <el-option :key="0" value="0" label="全部"></el-option>
                        <el-option
                          v-for="item in resData.owner_option"
                          :key="item.value"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.application_name"
                        placeholder="申请人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.audit_name"
                        placeholder="审核人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.sku"
                        placeholder="sku"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select v-model="form.source" placeholder="欠货来源">
                        <el-option value="0" label="全部"></el-option>
                        <el-option value="100" label="代采欠货"></el-option>
                        <el-option value="1" label="退换货欠货"></el-option>
                        <el-option value="2" label="售后欠货"></el-option>
                        <el-option value="3" label="售后退供"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="">
                      <el-select
                        v-model="form.p_reason_id"
                        placeholder="一级原因"
                        @change="setReson"
                      >
                        <el-option
                          :key="0"
                          :value="'0'"
                          label="全部"
                        ></el-option>
                        <el-option
                          v-for="item in resData.reasonOption"
                          :key="item.reason_id"
                          :label="item.reason_name"
                          :value="item.reason_id"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="form.reason_id"
                        placeholder="二级原因"
                      >
                        <el-option
                          :key="0"
                          :value="'0'"
                          label="全部"
                        ></el-option>
                        <el-option
                          v-for="item in subReasonOption"
                          :key="item.reason_id"
                          :label="item.reason_name"
                          :value="item.reason_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select v-model="form.status" placeholder="请选择">
                        <el-option
                          v-for="item in statusOption"
                          :key="item.status"
                          :label="item.status_value"
                          :value="item.status"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.dgid"
                        filterable
                        placeholder="次品组"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.dg_group"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.dpc_id"
                        filterable
                        placeholder="退换货负责人"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.option_dgm"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.cg_type"
                        placeholder="代采单类型"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.cg_type_option"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.refunder_id"
                        placeholder="售后退供员"
                        filterable
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.dgm_refunder"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="form.id" placeholder="坏账单ID">
                      </el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.owe_label"
                        placeholder="代采欠货标签"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in oweLabelOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input
                        v-model="form.stock_out_create_admin_str"
                        placeholder="扫码出库人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item label="订单生成时间：">
                  <el-date-picker
                    v-model="form.wo_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="申请时间：">
                  <el-date-picker
                    v-model="form.application_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="审核时间：">
                  <el-date-picker
                    v-model="form.auditor_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="退换货生成时间">
                  <el-date-picker
                    v-model="form.stock_out_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            position: relative;
          "
        >
          <el-button
            style="position: absolute; top: 8px; right: 5px"
            type="success"
            size="small"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" label="选择"></el-table-column>
            <el-table-column prop="id" label="坏账单ID" align="center">
            </el-table-column>
            <el-table-column
              prop="goods_img"
              label="图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.main_img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="woid"
              label="代采单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wcg_order_cg_type_text"
              label="代采单类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wo_create_time"
              label="代采单生成时间"
            ></el-table-column>
            <el-table-column align="center" prop="source" label="欠货来源">
              <template #default="{ row }">
                <div>{{ row.source }}</div>
                <div v-if="row.is_transit_formal" style="color: #006cff">
                  {{ row.is_transit_formal }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="right"
              prop="market_name"
              label="市场"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="order_owner_name"
              label="订单负责人"
            ></el-table-column>
            <el-table-column
              prop="dg_group_name"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              label="退换货负责人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refunder"
              filterable
              label="售后退供员"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sku"
              label="sku"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="price"
              label="代采单价"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="first_reson"
              label="一级原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="second_reson"
              label="二级原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="application_name"
              label="申请人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="application_time"
              label="申请时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="broken_debts_record_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="audit_name"
              label="审核人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="auditor_remark"
              label="审核备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="审核时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stock_out_create_admin_str"
              label="扫码出库人"
              show-overflow-tooltip
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="stock_out_create_time"
              label="退换货生成时间"
              show-overflow-tooltip
              align="center"
              width="150"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, sizes, jumper"
            :total="resData.count"
            :page-size="form.page_size"
            :page-sizes="[50, 100]"
            @current-change="handleCurrentChange"
            @size-change="
              (v) => {
                form.page_size = v;
                fetchData();
              }
            "
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      condition: 1,
      resData: {
        pgOption: [],
        reasonOption: [],
        list: [],
        count: 0,
      },
      subReasonOption: [],
      supply: {
        list: [],
      },
      form: {
        reason_id: "0",
        p_reason_id: "0",
        wo_create_time: [],
        application_time: this.defaultDate(),
        page_size: 100,
        city: [],
        cg_type: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/BrokenDebts/getAllBrokenDebts",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      statusOption: [
        { status: "0", status_value: "全部" },
        { status: "10", status_value: "财务审核通过" },
      ],
      cgTypeOption: [],
      citys: CITY,
      oweLabelOptions: [
        {
          label: "订单欠货",
          value: "1",
        },
        {
          label: "在途库存",
          value: "2",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    // 坏账分类
    setReson(reason_id) {
      this.subReasonOption = [];
      this.form.reason_id = "0";
      for (const key in this.resData.reasonOption) {
        const item = this.resData.reasonOption[key];
        if (item.reason_id == reason_id) {
          this.subReasonOption = item.children;
        }
      }
    },
    addColor({ row, column, columnIndex }) {
      if (columnIndex === 15) {
        return "blue-cell";
      }
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.form.condition = this.condition;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.resData = res.data.data;
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.condition = 0;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseAllBrokenDebts.vue